module.exports = __webpack_public_path__ + "img/desktop.130ed8b0.jpg";